import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SelectSearchModule } from 'shared/modules/controls/select-search/select-search.module';
import { SelectModule } from 'shared/modules/controls/select/select.module';
import { UploadFileButtonModule } from 'shared/modules/controls/upload-file-button/upload-file-button.module';
import { DirectivesModule } from 'shared/modules/directives/directives.module';
import { MaterialModule } from 'shared/modules/material/material.module';
import { TypographyModule } from 'shared/modules/typography/typography.module';
import { ChipNumberQueryInputComponent } from './chip-number-query-input/chip-number-query-input.component';
import { ChipStringQueryInputComponent } from './chip-string-query-input/chip-string-query-input.component';
import { QueryBuilderCompatModule } from './compat/query-builder-compat.module';
import { DatetimeQueryInputComponent } from './datetime-query-input/datetime-query-input.component';
import { MultipleEntityQueryInputComponent } from './multiple-entity-query-input/multiple-entity-query-input.component';
import { PasteQueryFromSavedComponent } from './query-builder-dialog/paste-query-from-saved/paste-query-from-saved.component';
import { QueryBuilderDialogComponent } from './query-builder-dialog/query-builder-dialog.component';
import { QueryBuilderDialogService } from './query-builder-dialog/query-builder-dialog.service';
import { AppendQueryPopoverComponent } from './query-builder-dialog/save-query-popover/append-query-popover.component';
import { QueryBuilderComponent } from './query-builder.component';
import { RoutableQueryBuilderComponent } from './routable-query-builder/routable-query-builder.component';
import { SimpleNumberQueryInputComponent } from './simple-number-query-input/simple-number-query-input.component';
import { SimpleStringQueryInputComponent } from './simple-string-query-input/simple-string-query-input.component';
import { SingleEntityQueryInputComponent } from './single-entity-query-input/single-entity-query-input.component';

@NgModule({
  declarations: [
    QueryBuilderComponent,
    QueryBuilderDialogComponent,
    AppendQueryPopoverComponent,
    PasteQueryFromSavedComponent,
    SimpleStringQueryInputComponent,
    ChipStringQueryInputComponent,
    SimpleNumberQueryInputComponent,
    ChipNumberQueryInputComponent,
    SingleEntityQueryInputComponent,
    MultipleEntityQueryInputComponent,
    DatetimeQueryInputComponent,
    RoutableQueryBuilderComponent,
  ],
  imports: [
    TranslateModule,
    CommonModule,
    MaterialModule,
    QueryBuilderCompatModule,
    FormsModule,
    ReactiveFormsModule,
    UploadFileButtonModule,
    SelectModule,
    ScrollingModule,
    SelectSearchModule,
    DirectivesModule,
    TypographyModule,
  ],
  exports: [
    QueryBuilderComponent,
    QueryBuilderDialogComponent,
  ],
  providers: [QueryBuilderDialogService],
})
export class QueryBuilderModule {
}
